export default __webpack_public_path__ + "b1f3960e1af89bfdd645ba54b8cbfea0.svg";